'use strict';

var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

require("core-js/modules/es.array.slice.js");

var Helper = {
  parseMask: parseMask,
  splitOnce: splitOnce
};
module.exports = Helper;

function parseMask(mask) {
  var nick = '';
  var user = '';
  var host = '';

  var sep1 = _indexOfInstanceProperty(mask).call(mask, '!');

  var sep2 = _indexOfInstanceProperty(mask).call(mask, '@');

  if (sep1 === -1 && sep2 === -1) {
    // something
    if (_indexOfInstanceProperty(mask).call(mask, '.') > -1) {
      host = mask;
    } else {
      nick = mask;
    }
  } else if (sep1 === -1 && sep2 !== -1) {
    // something@something
    nick = mask.substring(0, sep2);
    host = mask.substring(sep2 + 1);
  } else if (sep1 !== -1 && sep2 === -1) {
    // something!something
    nick = mask.substring(0, sep1);
    user = mask.substring(sep1 + 1);
  } else {
    // something!something@something
    nick = mask.substring(0, sep1);
    user = mask.substring(sep1 + 1, sep2);
    host = mask.substring(sep2 + 1);
  }

  return {
    nick: nick,
    user: user,
    host: host
  };
}

function splitOnce(input, separator) {
  if (typeof input !== 'string' || typeof separator !== 'string') {
    throw new TypeError('input and separator must be strings');
  }

  var splitPos;

  if (separator === '') {
    // special handling required for empty string as separator
    // cannot match '' at start, so start searching after first character
    splitPos = _indexOfInstanceProperty(input).call(input, separator, 1);

    if (splitPos === input.length) {
      // cannot match '' at end, so if that's all we found, act like we found nothing
      splitPos = -1;
    }
  } else {
    // normal non-zero-length separator
    splitPos = _indexOfInstanceProperty(input).call(input, separator);
  } // no separator found


  if (splitPos < 0) {
    return [input];
  } // the normal case: split around first instance of separator


  return [_sliceInstanceProperty(input).call(input, 0, splitPos), _sliceInstanceProperty(input).call(input, splitPos + separator.length)];
}